import classNames from "classnames/dedupe";
import { Container } from "@simplybusiness/mobius";
import { Logo } from "../Logo";
import type { WithMetadata } from "../../../pages";
import type { HeaderProps } from "../types";
import { ContactDetails } from "../ContactDetails";
import { ProvidedBySB } from "./ProvidedBySB";

export function CompareTheMarketHeader({
  componentName,
  variant,
  className,
  url,
  productTitle,
  phoneNumber,
  openingHours,
  supportUrl,
  partnerSubHeader,
  partnerSubHeaderText,
  ...otherProps
}: WithMetadata<HeaderProps>) {
  const classes = classNames("mobius", "mobius-header", className);

  return (
    <header
      className={classes}
      {...otherProps}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
    >
      <div className="mobius-header__container">
        <Container size="sm" className="mobius-header__content">
          <Logo url={url} />
          {productTitle && (
            <span className="mobius-header__product-title">{productTitle}</span>
          )}
          <ProvidedBySB />
          <ContactDetails
            phoneNumber={phoneNumber}
            openingHours={openingHours}
            supportUrl={supportUrl}
            openingHoursLabel="See our opening hours"
          />
        </Container>
      </div>
    </header>
  );
}
